// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ae-z","heading":"Be-z","brandPromo":"Ce-z"};